<div class="approvers-container" [ngStyle]="{width: width ? width : 'inherit'}">
    <p class="mb-4">
        <strong [innerHTML]="title"></strong>
    </p>
    <ui-lookup
        propertyNameToDisplay="fullName"
        placeholderText="Search by name or email"
        [maxQueryLength]="250"
        [dataSource]="lookupPeople$"
        [dataField]="preselectedUser"
        [value]="preselectedUser"
        [clearOnInput]="true"
        [disabled]="isApproversDisabled"
        (onSelectData)="userChanged($event)">
        <ng-template let-option="option" let-query="query">
            <ui-lookup-option [option]="option" [query]="query"></ui-lookup-option>
        </ng-template>
    </ui-lookup>
    <employee-chips [chipsList]="selectedApprovers"
                    (updateList)="updateApproversList($event)"></employee-chips>
</div>
